"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validateIdExpirationDate = (value) => {
    if (!value)
        return undefined;
    const date = new Date(value);
    if ((value.length !== 0 && value.length !== 10) || isNaN(date.getTime())) {
        return 'Expected format should be mm/dd/yyyy';
    }
    if (date.toISOString() < new Date().toISOString()) {
        return 'ID Expiration Date must be in the future';
    }
    return undefined;
};
exports.default = validateIdExpirationDate;
